"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.variantWithQueryParameterValues = exports.productWithQueryParameterValues = void 0;
const attributes_1 = require("../helpers/attributes");
function productWithQueryParameterValues(productWith) {
    const parameterValues = [];
    parameterValues.push(...(0, attributes_1.attributeIncludeParameters)('attributes', productWith.attributes), ...(0, attributes_1.attributeIncludeParameters)('advancedAttributes', productWith.advancedAttributes));
    if (productWith.variants) {
        parameterValues.push('variants');
        if (productWith.variants && typeof productWith.variants === 'object') {
            parameterValues.push(...(0, attributes_1.prefixList)('variants.')(variantWithQueryParameterValues(productWith.variants)));
        }
    }
    if (!productWith.images || productWith.images === 'all') {
        parameterValues.push(`images.attributes:legacy(false)`);
    }
    else if (productWith.images.attributes) {
        const imagesAttributesFilters = [];
        imagesAttributesFilters.push('legacy(false)');
        if (productWith.images.attributes.withKey) {
            imagesAttributesFilters.push(`key(${productWith.images.attributes.withKey.join('|')})`);
        }
        if (imagesAttributesFilters.length > 0) {
            parameterValues.push(`images.attributes:${imagesAttributesFilters.join(':')}`);
        }
    }
    if (productWith.categories) {
        if (typeof productWith.categories === 'object') {
            const categoryFlags = [];
            if (productWith.categories.includeHidden) {
                categoryFlags.push('hidden(true)');
            }
            if (productWith.categories.countryLevelCustomData) {
                parameterValues.push('categories.countryLevelCustomData');
            }
            if (productWith.categories.shopLevelCustomData) {
                parameterValues.push('categories.shopLevelCustomData');
            }
            if (productWith.categories.properties == 'all') {
            }
            else if (typeof productWith.categories.properties === 'object') {
                categoryFlags.push(`properties(${productWith.categories.properties.withName.join('|')})`);
            }
            else {
                categoryFlags.push(`properties()`);
            }
            if (categoryFlags.length > 0) {
                parameterValues.push(`categories:${categoryFlags.join(':')}`);
            }
            else {
                parameterValues.push('categories');
            }
        }
        else if (productWith.categories == 'all') {
            parameterValues.push('categories:properties()');
        }
    }
    if (productWith.siblings) {
        parameterValues.push('siblings');
        if (productWith.siblings && typeof productWith.siblings === 'object') {
            parameterValues.push(...productWithQueryParameterValues(productWith.siblings).map(queryParameter => `siblings.${queryParameter}`));
        }
    }
    if (productWith.priceRange === true) {
        parameterValues.push('priceRange');
    }
    if (productWith.reductionRange === true) {
        parameterValues.push('reductionRange');
    }
    if (productWith.baseCategories === true) {
        parameterValues.push('baseCategories');
    }
    if (productWith.lowestPriorPrice === true) {
        parameterValues.push('lowestPriorPrice');
    }
    if (productWith.searchCategoryIds === true) {
        parameterValues.push('searchCategoryIds');
    }
    return parameterValues;
}
exports.productWithQueryParameterValues = productWithQueryParameterValues;
function variantWithQueryParameterValues(variantWith) {
    return [
        ...(0, attributes_1.attributeIncludeParameters)('attributes', variantWith.attributes),
        ...(0, attributes_1.attributeIncludeParameters)('advancedAttributes', variantWith.advancedAttributes),
        ...(variantWith.lowestPriorPrice ? ['lowestPriorPrice'] : []),
        ...(variantWith.stock ? ['stock'] : []),
        ...(variantWith.stock &&
            typeof variantWith.stock === 'object' &&
            variantWith.stock.customData
            ? ['stock.customData']
            : []),
    ];
}
exports.variantWithQueryParameterValues = variantWithQueryParameterValues;
